import { render, staticRenderFns } from "./accessories.vue?vue&type=template&id=3a42fbc5&"
import script from "./accessories.vue?vue&type=script&lang=js&"
export * from "./accessories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports